import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Content Card',
  name: 'contentCard',
  type: 'object',
  fields: [
    defineField({
      title: 'Top Title',
      name: 'topTitle',
      type: 'string',
    }),
    defineField({
      title: 'Main Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'text',
    }),
    defineField({
      title: 'Background',
      name: 'bg',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
  ],
})